// extracted by mini-css-extract-plugin
export default {"loader__wrapper":"FwFWrpqGSsatxdBJ3OCL","loader":"_AmuOE3Ki5oxvTRnMfQI","spin988":"QC5rwkd_IKTXNW5DUh3o","circle":"HB3x4HeKByV3Yu_47RAE","fade-in":"RTGIkS1r21QYxzcdugv6"};